<!--
    @负责人: libaiqi
    @创建时间: 2019-02-27
    @版本:v2.0.2
    @描述: 远程配置-修改
-->
<template>
  <div class="editSite__content">
    <div class="editSite__operation">
      <el-button type="primary"  @click="e_edit" v-g-rac="gRac('remoteConfig@save')">{{ $t('common.save') }}</el-button>
      <el-button type="danger"  @click="e_delete" v-g-rac="gRac('remoteConfig@delete')">{{ $t('common.delete') }}</el-button>
      <el-button type="primary"  @click="e_cancel">{{ $t('common.cancel') }}</el-button>
    </div>
    <div class="editSite__title">{{ $t('remoteConfig.uploadConfig') }}</div>
    <div class="editSite__form">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item :label="$t('remoteConfig.siteCode')">
          {{ siteCode }}
        </el-form-item>
        <el-form-item :label="$t('remoteConfig.siteName')">
          {{ siteName }}
        </el-form-item>
        <el-form-item :label="$t('remoteConfig.uploadAlarm')">
          <el-radio-group v-model="form.uploadAlarm" class="createVersion__radio">
            <el-radio :label="index" v-for="(item,index) in booleanList" :key="index">{{item}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('remoteConfig.uploadKpi')">
          <el-radio-group v-model="form.uploadKpi" class="createVersion__radio">
            <el-radio :label="index" v-for="(item,index) in booleanList" :key="index">{{item}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('remoteConfig.uploadHostInfo')">
          <el-radio-group v-model="form.uploadHostInfo" class="createVersion__radio">
            <el-radio :label="index" v-for="(item,index) in booleanList" :key="index">{{item}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('remoteConfig.uploadFileSite')">
          <el-select v-model="form.uploadFileSite">
            <el-option v-for="(item,index) in siteList" :label="item" :value="index" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('remoteConfig.uploadPaas')">
          <el-select v-model="form.uploadPaas">
            <el-option v-for="(item,index) in siteList" :label="item" :value="index" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form> 
    </div>
  </div>
</template>
<script type="text/javascript">
  import rac from '@/plugins/rac-mixin'
  import remoteConfigBiz from '@/logic/systemSetting/remoteConfigBiz.js'
  import dic from '@/components/mixins/dic'
  export default {
    mixins: [rac, dic],
    data () {
      return {
        form: {
          uploadAlarm: 'true',
          uploadKpi: 'true',
          uploadHostInfo: 'true',
          uploadFileSite: '',
          uploadPaas: ''
        },
        id: '',
        siteName: '',
        siteCode: '',
        booleanList: {
          'true': this.$t('remoteConfig.yes'),
          'false': this.$t('remoteConfig.no')
        },
        siteList: {}
      }
    },
    methods: {
      async waitSiteList () {
        await this.dGetDictionaryByCode('remoteconfig')
        this.siteList = { ...this.dDictionary.remoteconfig }
        this.form.uploadFileSite = Object.keys(this.siteList)[0]
        this.form.uploadPaas = Object.keys(this.siteList)[0]
      },
      init () {
        this.waitSiteList()
        this.getSite()
      },
      getSite () {
        remoteConfigBiz.findAll({siteCode: this.$route.query.siteCode}).then((data) => {
          let res = data.filter(item => item.siteCode === this.$route.query.siteCode)[0]
          this.siteCode = res.siteCode
          this.siteName = res.siteName
          this.id = res.id
          this.form = {
            uploadAlarm: res.uploadAlarm ? 'true' : 'false',
            uploadKpi: res.uploadKpi ? 'true' : 'false',
            uploadHostInfo: res.uploadHostInfo ? 'true' : 'false',
            uploadFileSite: res.uploadFileSite ? res.uploadFileSite : Object.keys(this.siteList)[0],
            uploadPaas: res.uploadPaas ? res.uploadPaas : Object.keys(this.siteList)[0]
          }
        })
      },
      e_delete () {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          let data = {
            id: this.id,
            nodeConfig: {
              uploadAlarm: false,
              uploadKpi: false,
              uploadHostInfo: false,
              uploadFileSite: Object.keys(this.siteList)[0],
              uploadPaas: Object.keys(this.siteList)[0]
            }
          }
          this.e_req(data)
        }).catch(() => {})
      },
      e_cancel () {
        this.$router.push({name: 'remoteConfig'})
      },
      e_edit () {
        let data = {
          id: this.id,
          nodeConfig: {
            uploadAlarm: this.form.uploadAlarm === 'true',
            uploadKpi: this.form.uploadKpi === 'true',
            uploadHostInfo: this.form.uploadHostInfo === 'true',
            uploadFileSite: this.form.uploadFileSite,
            uploadPaas: this.form.uploadPaas
          }
        }
        this.e_req(data)
      },
      e_req (data) {
        remoteConfigBiz.update(data).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          setTimeout(() => {
            this.e_cancel()
          }, 500)
        })
      }
    },
    mounted () {
      this.init()
    },
    watch: {
      '$route' (nV, oV) {
        if (nV.name === 'editSite' && oV.name === 'remoteConfig') {
          this.getSite()
        }
      }
    }
  }
</script>
<style scoped>
  .editSite__title {
    font-size: 16px;
    font-weight: 700;
    margin: 10px 0;
  }
  .editSite__form {
    height: 360px;
    width: 450px;
    border: 1px rgba(0, 0, 0, 0.5) solid;
  }
</style>
  